
  import { defineComponent, inject, PropType } from 'vue';

  import Constants from '@/common/constants';
  import IconComponent from '@/common/ui/IconComponent.vue';

  import { EVENTS_TABLE_ACTIONS } from '../constants/constants';
  import { EVENTS_VES_ACTIONS_NAME } from '../store/events/name';
  import { TEventsTableActions, TEventsTableItem } from '../types/events';

  export default defineComponent({
    name: 'EventsVESTableActionsCell',
    components: { IconComponent },
    props: {
      row: {
        type: Object as PropType<TEventsTableItem>,
        required: true,
      },
    },
    setup() {
      const tableActions = inject<TEventsTableActions | null>(EVENTS_TABLE_ACTIONS, null);
      return { tableActions };
    },
    methods: {
      onEdit() {
        this.tableActions?.onEdit(this.row);
      },
      async onDelete() {
        const result = await Constants.alert.fire({
          title: 'Удалить мероприятие?',
          text: `Вы действительно хотите удалить мероприятие "${this.row.name || ''}"?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Удалить',
          cancelButtonText: 'Отмена',
        });

        if (!result.isConfirmed) return;

        try {
          const res = await this.$store.dispatch(EVENTS_VES_ACTIONS_NAME.deleteEvent, this.row.id);
          if (!res?.success) {
            this.showDeleteError();
            return;
          }

          Constants.alert.fire('Удалено', 'Мероприятие удалено', 'success');
          this.tableActions?.onDeleted?.();
        } catch {
          this.showDeleteError();
        }
      },
      showDeleteError() {
        Constants.alert.fire(Constants.errorTitle, 'Не удалось удалить мероприятие', 'error');
      },
    },
  });
